// src/components/PickerWheel.js
//
// The scroll wheel every picker in the app turns: one column of values that
// snaps to the item under the band and reports a change once it settles.
// Lived in App.js; the goal sheets in src/components need it too.

import React, { useEffect, useRef } from "react";

export const WHEEL_ITEMH = 46;
export const wpad = (n) => String(n).padStart(2, "0");
export function markMid(el) {
  const idx = Math.max(0, Math.round(el.scrollTop / WHEEL_ITEMH));
  el.querySelectorAll(".gwWi").forEach((c, i) => c.classList.toggle("mid", i === idx));
}

export function PickerWheel({ max, min = 0, initial, refObj, labels, onChange, ariaLabel, focusable = true }) {
  const ref = useRef(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  // The value last handed out. The mount scroll and the smooth snap both
  // settle on it; only a change is reported — opening the time row on a
  // finish-only goal used to invent a 12:00 target this way.
  const lastReported = useRef(initial != null ? initial : min);
  useEffect(() => {
    if (refObj) refObj.current = ref.current;
    if (ref.current) requestAnimationFrame(() => { if (ref.current) { ref.current.scrollTop = Math.max(0, (initial || min) - min) * WHEEL_ITEMH; markMid(ref.current); } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // A range that shrinks under the column (31 → 30 days) pulls it back
  // inside; the scroll it causes reports the clamped value.
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const top = Math.max(0, (max - min) * WHEEL_ITEMH);
    if (el.scrollTop > top) { el.scrollTop = top; markMid(el); }
  }, [max, min]);
  const tRef = useRef(null);
  useEffect(() => () => clearTimeout(tRef.current), []);
  const onScroll = () => {
    const el = ref.current; if (!el) return;
    markMid(el);
    clearTimeout(tRef.current);
    tRef.current = setTimeout(() => {
      if (!el.isConnected) return;
      const idx = Math.max(0, Math.round(el.scrollTop / WHEEL_ITEMH));
      const target = idx * WHEEL_ITEMH;
      if (Math.abs(el.scrollTop - target) > 1) el.scrollTo({ top: target, behavior: "smooth" });
      const value = min + Math.min(idx, Math.max(0, max - min));
      if (value === lastReported.current) return;
      lastReported.current = value;
      if (onChangeRef.current) onChangeRef.current(value);
    }, 90);
  };
  const items = [];
  for (let i = min; i <= max; i++) items.push(<div className="gwWi" key={i}>{labels ? (labels[i - min] != null ? labels[i - min] : wpad(i)) : wpad(i)}</div>);
  return <div className="gwWcol" ref={ref} onScroll={onScroll} tabIndex={focusable ? 0 : -1} aria-label={ariaLabel}>{items}</div>;
}
